/**
 * @fileoverview PATCH handler for the "/companies/:company_id/mobile_app_linking_configs/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { patchCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys } from "./constants";
import type {
  PatchCompaniesCompanyIdMobileAppLinkingConfigsIdProps,
  PatchCompaniesCompanyIdMobileAppLinkingConfigsIdResult,
} from "./types";

export const patchCompaniesCompanyIdMobileAppLinkingConfigsId = reactQueryMutationAdapter(
  patchCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys,
  ({
    companyId,
    id,
    name,
    iosConfig,
    androidConfig,
  }: PatchCompaniesCompanyIdMobileAppLinkingConfigsIdProps): Promise<PatchCompaniesCompanyIdMobileAppLinkingConfigsIdResult> => {
    return fetch(
      `/companies/${companyId}/mobile_app_linking_configs/${id}`,
      "PATCH",
      {
        name,
        // Wire params are snake_case (house rule; matches the assignments endpoints).
        // The payload documents themselves are free-form and pass through untouched.
        ios_config: iosConfig && { enabled: iosConfig.enabled, aasa_payload: iosConfig.aasaPayload },
        android_config: androidConfig && {
          enabled: androidConfig.enabled,
          assetlinks_payload: androidConfig.assetlinksPayload,
        },
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
